import type { WorkOrderVersionActKc2VersionData } from 'gql/graphql';
import { ContractOtherStatusEnum } from 'gql/graphql';
import { formatNumberToRu } from 'utils';

import * as R from 'ramda';

export const TABLE_GROUP_NAME: { [index: string]: string } = {
    CUSTOMER_LIMITS: 'Лимиты Заказчика',
    CHAPTER9: 'Прочие затраты 9 Главы',
    WORK_ORDER_TOTALS: 'Итоги НЗ',
    OTHERS: 'Прочие',
};

// TODO: !!!
const prepareSeasons = (item: any) => ({
    ...item?.seasonPrices?.reduce((acc: any, seasonItem: any) => {
        const { remainderCost, seasonId } = seasonItem;

        acc[`seasonValue_${seasonId}`] = formatNumberToRu(remainderCost, 2);

        return acc;
    }, {}),
});

// TODO: !!!
const prepareActs = (item: any) => ({
    ...item?.actKC2VersionPrices?.reduce(
        (
            acc: any,
            value: {
                actKC2VersionId: any;
                planCost: any;
                planCostDeviation: any;
                acceptedCost: any;
                acceptedCostDeviation: any;
            },
        ) => {
            acc[`actKC2PlanCost_${value.actKC2VersionId}`] = formatNumberToRu(value.planCost, 2);
            acc[`actKC2PlanCostDeviation_${value.actKC2VersionId}`] = value.planCostDeviation;
            acc[`actKC2AcceptedCost_${value.actKC2VersionId}`] = formatNumberToRu(value.acceptedCost, 2);
            acc[`actKC2AcceptedCostDeviation_${value.actKC2VersionId}`] = value.acceptedCostDeviation;

            return acc;
        },
        {},
    ),
});

// TODO: !!!
export const preparedOtherData = ({
    otherPriceDataItem,
    actsKC2,
}: {
    otherPriceDataItem: any;
    actsKC2: WorkOrderVersionActKc2VersionData[];
}) => ({
    ...otherPriceDataItem,
    totalPlanCost: formatNumberToRu(otherPriceDataItem.totalPlanCost, 2),
    totalCompletedCost: formatNumberToRu(otherPriceDataItem.totalCompletedCost, 2),
    totalRemainderCost: formatNumberToRu(otherPriceDataItem.totalRemainderCost, 2),
    type: otherPriceDataItem.status === ContractOtherStatusEnum.NewRecord ? 'OTHERS_NEW' : 'OTHERS',
    ...prepareSeasons(otherPriceDataItem),
    ...prepareActs(otherPriceDataItem),
    actKC2Prices: otherPriceDataItem.actKC2VersionPrices?.map((priceItem: { actKC2VersionId: any }) => ({
        ...priceItem,
        actKC2status: actsKC2.find((act) => act.id === priceItem.actKC2VersionId)?.status,
    })),
});

// TODO: !!!
export const getGroupedOtherItems = ({
    otherPriceList,
    actsKC2,
    tableFilters,
}: {
    otherPriceList: any[];
    actsKC2: WorkOrderVersionActKc2VersionData[];
    tableFilters: { code?: string; name?: string };
}) => {
    if (!otherPriceList) {
        return [];
    }

    const items = Object.values(
        otherPriceList?.reduce((acc: any, item) => {
            const { chapter, section } = item;
            const groupName = chapter || section;

            if (groupName) {
                const preparedItem = preparedOtherData({
                    otherPriceDataItem: item,
                    actsKC2,
                });

                if (!acc[groupName]) {
                    acc[groupName] = {
                        id: groupName,
                        name: TABLE_GROUP_NAME[groupName],
                        rows: [],
                    };
                }

                acc[groupName].rows.push(preparedItem);
            }

            return acc;
        }, {}),
    );

    const matchFilters = (item: any, filters: any) =>
        Object.entries<string>(filters).reduce((acc, [key, filterValue]) => {
            const itemValue = item?.[key]?.toLocaleLowerCase();

            const filterValueLowered = R.is(String, filterValue) ? filterValue?.toLocaleLowerCase() : filterValue;

            acc = acc && itemValue.includes(filterValueLowered);

            return acc;
        }, true);

    if (!R.isEmpty(tableFilters)) {
        const filteredData = items.reduce((acc: any, item: any) => {
            const filteredItems = item.rows.filter((row: any) => matchFilters(row, tableFilters));

            if (filteredItems.length) {
                acc = [...acc, { ...item, rows: filteredItems }];
            }

            return acc;
        }, []);

        return filteredData;
    }

    return items;
};
